/* global axios */
import ApiClient from './ApiClient';

class TalkviaSmsAPI extends ApiClient {
  constructor() {
    super('talkvia_sms', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(recipients, message) {
    return axios.post(this.url, {
      recipients,
      message,
    });
  }

  details(id) {
    return axios.get(`${this.url}/${id}`);
  }

  export(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }
}

export default new TalkviaSmsAPI();
